import * as React from "react";
import { Form, Input, Button, Row, Col, message } from "antd";
import { Link } from "react-router-dom";
import { users } from "@/api";
import { omit } from "@/util";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import lockIcon from "../../../assets/images/lock.svg";
import userIcon from "../../../assets/images/user.svg";
import callIcon from "../../../assets/images/call.svg";

const Container = styled.div`
  width: 400px;
  border-radius: 16px;
  background: white;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .atitle {
    display: flex;
    width: 100%;
    align-items: center;
    color: var(--Dark, #0F172A);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    padding-top: 30px;
    padding-bottom: 20px;
    justify-content: center;
  }
  .form {
    width: 280px;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 30px;
  }
  .icon{
    width: 16px;
    height: 16px;
  }
  .input{
    height: 35px;
    border-radius: 16px;
    border: 1px solid #ECEEF1;
    margin-top: 5px;
  }
  .ant-form-item{
    margin-bottom: 10px;
  }
  .tag {
    color: #374151;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: -0.12px;
    padding-left: 15px;
  }
  .buttonRegister {
    border-radius: 16px;
    background: var(--Brand-color, #00AEEF);
  }
`;

const LosePass: React.FunctionComponent = () => {
  const history = useHistory();
  const [downNumber, setDownNumber] = React.useState(0);
  const [phoneNumber, setPhoneNumber] = React.useState("");

  React.useEffect(() => {
    if (downNumber > 0) {
      setTimeout(() => {
        setDownNumber(downNumber - 1);
      }, 1000);
    }
  }, [downNumber]);
/*React.useMemo被用来优化性能，避免在每次组件渲染时都重新计算buttonTxt的值。*/ 
  const buttonTxt = React.useMemo(
    () => (downNumber === 0 ? "Баталгаажуулах код илгээх" : `${downNumber} S`),
    [downNumber]
  );

  const handleSubmit = async (values: any) => {
    values.checkCode=123456;
    const params: users.RegProps = omit(
      values,
      "cfmPassword"
    ) as users.RegProps;
    await users.forgetpassword(params);
    message.success("Нууц үг амжилттай солигдлоо");
    history.replace("/login");
  };

  const sendCaptcha = async () => {
    if (!/1[\d]{10}/.test(phoneNumber)) {
      message.error("Утасны дугаар буруу байна");
      return;
    }
    await users.sendcode(phoneNumber);
    setDownNumber(59);
  };

  const phoneChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setPhoneNumber(v);
  };

  return (
    <Container>
      <Form onFinish={handleSubmit} className="form">
        <div className="atitle">
          Нууц үг сэргээх
        </div>
        <span className="tag"> Утасны дугаар </span>
        <Form.Item
          name="username"
          rules={[{ required: true, message: "Утасны дугаар хоосон байна" }]}
        >
          <Input className="input" prefix={<img className="mr3 ml3 icon" src={callIcon} alt="callIcon" />} placeholder="Утасны дугаараа оруулна уу" onChange={phoneChangeHandler} />
        </Form.Item>

        <span className="tag"> Нууц үг </span>
        <Form.Item
          name="password"
          rules={[{ required: true, message: "Нууц үг хоосон байна" }]}
        >
          <Input className="input" prefix={<img className="mr3 ml3" src={lockIcon} alt="lockIcon" />} type="password" placeholder="Нууц үгээ оруулна уу" />
        </Form.Item>
        <span className="tag"> Нууц үг дахин оруулах </span>
        <Form.Item
          name="cfmPassword"
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Нууц үг ижил биш байна"));
              },
            }),
          ]}
        >
          <Input className="input" prefix={<img className="mr3 ml3" src={lockIcon} alt="lockIcon" />} type="password" placeholder="Нууц үгээ дахин оруулна уу" />
        </Form.Item>

        {/* <Form.Item>
          <Row gutter={8}>
            <Col span={16}>
              <Form.Item
                name="checkCode"
                noStyle
                rules={[{ required: true, message: "验证码不能为空" }]}
              >
                <Input placeholder="请输入收到的验证码" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button onClick={sendCaptcha} block style={{ width: "100%" }}>
                {buttonTxt}
              </Button>
            </Col>
          </Row>
        </Form.Item> */}

        <Form.Item>
          <Button className="buttonRegister mt10" type="primary" htmlType="submit" block>
            Өөрчлөх
          </Button>
        </Form.Item>
        <div className="mt10 jsc">
          <Link to="/login">Нэвтрэх</Link>
        </div>
      </Form>
    </Container>
  );
};

export default LosePass;
